import UdeskLocales from 'UdeskLocales';
import React from 'react';
import { Select } from 'udesk-ui';
import { SelectProps } from 'antd';
import { TicketType } from './const';

interface TemplateProps<T extends number | number[] | string | string[]> extends SelectProps<T> {}

const Template: <T extends number | number[] | string | string[]>(
    props: TemplateProps<T>
) => React.ReactElement | null = (props) => {
    const { ...restProps } = props;

    return (
        <Select
            options={[
                {
                    value: TicketType.CUSTOMER,
                    label: /* 客户 */ UdeskLocales['current'].components.ticketTypeSelect.index
                        .customer,
                },
                {
                    value: TicketType.AGENT,
                    label: /* 客服 */ UdeskLocales['current'].components.ticketTypeSelect.index
                        .customerService,
                },
                {
                    value: TicketType.REMARK,
                    label: /* 内部备注 */ UdeskLocales['current'].components.ticketTypeSelect.index
                        .internalRemarks,
                },
                {
                    value: TicketType.TEXTMSG,
                    label: /* 短信 */ UdeskLocales['current'].components.ticketTypeSelect.index.sMS,
                },
                {
                    value: TicketType.CALL,
                    label: /* 呼叫 */ UdeskLocales['current'].components.ticketTypeSelect.index
                        .call,
                },
                {
                    value: TicketType.EMAIL,
                    label: /* 邮件 */ UdeskLocales['current'].components.ticketTypeSelect.index
                        .mail,
                },
                {
                    value: TicketType.CHANGERECORD,
                    label: /* 变更记录 */ UdeskLocales['current'].components.ticketTypeSelect.index
                        .changeRecord,
                },
            ]}
            {...restProps}
        />
    );
};

export default Template;
